import React, { useEffect, useState } from 'react'
import { Accordion, AccordionSummary, AccordionDetails, Box } from '@mui/material'
import { FaChevronDown } from 'react-icons/fa6'
import ProfileScreen from 'src/Components/Onboarding/ProfileScreen'
import { useForm } from 'react-hook-form'
import { CURRENCY_CODE, DATE_FORMATE, HEAT_MAP, INITIAL_PROFILE_DATA, LANGUAGE } from 'src/Entities/OnBoardingContainerTypes'
import SelectInput from 'src/Common/ui/selectInput'
import CustomSelect from 'src/Common/ui/CustomSelect'
import { useProfileScreenStore } from 'src/Containers/Onboarding/Store/OnboardingStore'

const General = () => {
    const { reset, formState: { errors }, control, setError, clearErrors, register, setValue } = useForm({
        mode: 'onChange',
        defaultValues: {}
    })
    const { getCountry, getCountryData } = useProfileScreenStore()

    const [ expanded, setExpanded ] = useState(false)
    const [ profileData, setProfileData ] = useState(INITIAL_PROFILE_DATA)
    const [ country, setCountry ] = useState([])
    const handleChange = (panel) => (_, isExpanded) => {
        setExpanded(isExpanded ? panel : false)
    }

    useEffect(() => {
        if (getCountryData?.length > 0) {
            setCountry(getCountryData)
        }
    }, [getCountryData?.length])
    useEffect(() => {
        getCountry()
    }, [])

    return (
        <div style={{ maxWidth: '95%', margin: 'auto' }}>
            <Accordion expanded={expanded === 'panel1'} className='!border-2 !border-primary-foreground !rounded-[8px] !cursor-pointer !shadow-none !w-full !p-[10px]' onChange={handleChange('panel1')} sx={{ marginBottom: 2 }}>
                <AccordionSummary expandIcon={<FaChevronDown />} >
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
                        <div className='text-primary text-h4-selected' >Organizational Profile</div>
                        <Box sx={{ flexGrow: 1, height: '1px', backgroundColor: expanded === 'panel1' && 'lightgray', mx: 2, my: 1 }} />
                    </Box>
                </AccordionSummary>
                <AccordionDetails>
                    <ProfileScreen reset={reset} isDisabled={true} control={control} register={register} errors={errors} setError={setError} clearErrors={clearErrors} curencyCode={CURRENCY_CODE} dateFormat={DATE_FORMATE} heatMap={HEAT_MAP} profileData={profileData} setValue={setValue} setProfileData={setProfileData} className='px-4 flex-col items-center h-full flex justify-center' />
                </AccordionDetails>
            </Accordion>

            <Accordion expanded={expanded === 'panel2'} className='!border-2 !border-primary-foreground !rounded-[8px] !cursor-pointer !shadow-none !w-full !p-[10px]' onChange={handleChange('panel2')} sx={{ marginBottom: 2 }}>
                <AccordionSummary expandIcon={<FaChevronDown />} sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
                        <div className='text-primary text-h4-selected'>Regional</div>
                        <Box sx={{ flexGrow: 1, height: '1px', backgroundColor: expanded === 'panel2' && 'lightgray', mx: 2, my: 1 }} />
                    </Box>
                </AccordionSummary>
                <AccordionDetails>
                    <div style={{ pointerEvents: 'none', opacity: '0.5' }} className="grid grid-cols-3 gap-4 mt-4 mb-6">
                        <div style={{ width: '100%' }}>
                            <SelectInput
                                required errors={errors} control={control} name="language" label="Language" register={register} placeholder="Select Language"
                                rules={{
                                    required: 'Language Code is required'
                                }}
                                // readOnly={true}
                                value={1}
                                options={LANGUAGE.map(type => ({ value: type.id, label: type.name }))}
                            />
                        </div>
                        <div style={{ width: '100%' }}>
                            <CustomSelect
                                name={'countryId'}
                                label="Country"
                                options={country}
                                // disabled={true}
                                value={profileData?.orgAddress?.find((findData) => findData?.addressTypeId === 1)?.countryId || ''}
                                placeholder='Select Country'
                                errors={errors}
                                control={control}
                                required
                                rules={{ required: 'Country is required' }}
                            />
                        </div>
                        <div style={{ width: '100%' }}>
                            <SelectInput
                                required errors={errors} control={control} name="currencyCode" label="Currency" register={register} placeholder="Select Currency Code"
                                rules={{
                                    required: 'Currency Code is required'
                                }}
                                // readOnly={true}
                                value={profileData?.currencyCode}
                                options={CURRENCY_CODE.map(type => ({ value: type.id, label: type.name }))}
                            />
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>
        </div>
    )
}

export default General
